// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AbvW","label":"styles_label__12dBd"};